import { render, staticRenderFns } from "./SupervisionIndicators.vue?vue&type=template&id=0ba9e597"
import script from "./SupervisionIndicators.vue?vue&type=script&lang=js"
export * from "./SupervisionIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports